import React from 'react';

import {matchPath, useHistory, useLocation} from "react-router-dom";

import Breadcrumb from 'react-bootstrap/Breadcrumb';


const BreadCrumb = ({
	data,
	routes,
}) => {
	const location = useLocation();
	const history = useHistory();

	/*
	ugly implementation where every route has to be fully specified instead of having a mechanism that picks up
	earlier route-parts; eg. client-route has to specify the trainer part too instead of using the trainer-route.

	route defines path to match and a function that produces the crumbs, with a label and a target href for each crumb
	 */

	// find matching route
	const route = routes.find(r => matchPath(location.pathname, {
		...r,
		exact: true,
	}));

	const crumbled = route.crumble(data, matchPath(location.pathname, {
		...route,
		exact: true,
	}).params);


	const makeClickHandler = href => ev => {
		ev.preventDefault();
		history.push(href);
	};

	const crumbs = crumbled.map(({text, href}, idx) => {
		const active = idx === crumbled.length - 1;

		return (
			<Breadcrumb.Item
				key={idx}
				linkProps={{
					onClick: makeClickHandler(href),
				}}
				href={href}
				title={text}
				active={active}>
				{text}
			</Breadcrumb.Item>
		);
	});



	// render

	return (
		<Breadcrumb>
			{crumbs}
		</Breadcrumb>
	);
};


export default BreadCrumb;
